import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProjectSettings } from "./ui";

export const ProjectSettingsRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `${routes.general.settings()}`,
    element: createElement(ProjectSettings),
    children: [...rest],
  };
};
